import BooksitoutDemoImage from "../demos/BooksitoutDemoImage";
import BooksitoutProductType from "../../../booksitout/type/BooksitoutProductType";
import BooksitoutProductStatus from "../../../booksitout/type/BooksitoutProductStatus";
import BooksitoutImages from "../../../images/BooksitoutImages";

const BooksitoutProductBooksitout: BooksitoutProductType = {
	id: 'booksitout',
	status: BooksitoutProductStatus.PRODUCTION,
	name: {
		english: 'booksitout',
		url: 'booksitout',
	},
	icon: BooksitoutImages.WebsiteLogo.booksitout,
	link: [
		{
			link: 'https://booksitout.com',
			icon: BooksitoutImages.WebsiteLogo.booksitout,
			border: false,
		},
	],
	featuresCount: 5,
	demoImages: [],
	thumbnailImage: BooksitoutDemoImage.booksitout,
	detailImage: BooksitoutDemoImage.booksitout,
	privacyPolicyDates: ['2023-07-01']
}

export default BooksitoutProductBooksitout